export const ADD_SLIDE_NAME_REQUEST = " ADD_SLIDE_NAME_REQUEST";
export const ADD_SLIDE_NAME_SUCCESS = " ADD_SLIDE_NAME_SUCCESS";
export const ADD_SLIDE_NAME_FAILURE = " ADD_SLIDE_NAME_FAILURE";
